export default __webpack_public_path__ + "3d9f27e.png";